//Please don't add any extra component that will not be used in plugins
import { NotifierConstants } from "./components.constants.js";
import {Route} from "./registry/routes.js";

import ImagePreviewDialog from './components/core/ImagePreviewDialog.vue';
import Multiselect from 'vue-multiselect';
import DatePicker from "vue2-datepicker";
import highlightMixin from './mixins/highlightMixin.js';
import Pagination from "vue-pagination-2";
import moment from 'moment';
import { mapActions , mapGetters , mapMutations } from "vuex";
import suneditor from 'suneditor';
import en from 'suneditor/src/lang/en';
import plugins from 'suneditor/src/plugins';
import DragSelect from "dragselect";
import draggablePlugin from "vuedraggable";
import RichTextEditorComponent from "./components/core/RichTextEditor/RichTextEditor.vue";
import DisplayRichTextEditorContents from "./components/core/RichTextEditor/DisplayRichTextEditorContents.vue";
import RichtexteditorToggleToolbarButton from "./components/core/RichTextEditor/RichtextToolsToggleButton.vue";
export default{
        //constants
        //utils:{component:require('./components.utils.js').default},
        DragSelect,
        draggablePlugin,
        suneditor:suneditor,
        suneditorPlugins:plugins,
        suneditorLanguage:en,
        utils:require('./components.utils.js').default,
        //constants:{component:require("./components.constants.js").default},
        constants:require("./components.constants.js").default,
        //notifierConstants:{component:NotifierConstants},
        notifierConstants:NotifierConstants,

        //Route registry
        //routeRegistry:{component:Route}, 
        routeRegistry:Route, 
         
        //axios
        //axios:{component: require('axios').default},
        axios:require('axios').default,

        //inline icons
        //browseIcon:{component:require('./components/core/InlineBrowseField.vue').default},
        browseIcon:require('./components/core/InlineBrowseField.vue').default,
        //editIcon:{component:require("./components/core/InlineEditField.vue").default},
        editIcon:require("./components/core/InlineEditField.vue").default,
        //saveIcon:{component:require("./components/core/InlineSaveField.vue").default},
        saveIcon:require("./components/core/InlineSaveField.vue").default,
        //cancelIcon:{component:require("./components/core/InlineCancelField.vue").default},
        deleteIcon:require("./components/core/InlineDeleteIcon.vue").default,
        cancelIcon:require("./components/core/InlineCancelField.vue").default,
        //buttonWithArrow:{component: require('./components/core/ButtonWithArrowIcon.vue').default},
        buttonWithArrow: require('./components/core/ButtonWithArrowIcon.vue').default,

        //player
        //VideoPlayer: {component:  require("./components/core/VideoPlayer.vue").default},
        VideoPlayer: require("./components/core/VideoPlayer.vue").default,

        //users
        //userBrowser:{component:require('./components/userGroups/AddUserFromBrowse.vue').default},
        userBrowser:require('./components/userGroups/AddUserFromBrowse.vue').default,

        //core common components
        //attachments:{component:require('./components/core/Attachments.vue').default},
        attachments:require('./components/core/Attachments.vue').default,
        //fileBrowser:{component:require('./components/files/filesBrowse.vue').default},
        fileBrowser:require('./components/files/filesBrowse.vue').default,
        //highlightMixin:{component:highlightMixin},
        highlightMixin:highlightMixin,
        //DatePicker:{component:DatePicker},
        DatePicker:DatePicker,
        //openInCatalogBrowse:{component: require('./components/categories/OpenInCatalogBrowse.vue').default},
        openInCatalogBrowse:require('./components/categories/OpenInCatalogBrowse.vue').default,
        //userMultiSelectBrowser:{component:require('./components/users/UserMultiselectField.vue').default},
        userMultiSelectBrowser:require('./components/users/UserMultiselectField.vue').default,
        //miniPlayer:{component:require('./components/files/MiniPlayer.vue').default},
        miniPlayer:require('./components/files/MiniPlayer.vue').default,
        //imagePreviewDialog:{component:ImagePreviewDialog},
        imagePreviewDialog:ImagePreviewDialog,
        //imageAnnotationEditor:{component:require('./components/core/ImageAnnotationEditor.vue').default},
        imageAnnotationEditor:require('./components/core/ImageAnnotationEditor.vue').default,
        //previewUrl:{component:require('./components/core/PreviewUrl.vue').default},
        previewUrl:require('./components/core/PreviewUrl.vue').default,
        //shareInChat:{component:require('./components/core/ShareInChat.vue').default},
        shareInChat:require('./components/core/ShareInChat.vue').default,
        //multiselect:{component:Multiselect},
        multiselect:Multiselect,
        jobs:require('./components/jobs/Jobs.vue').default,
        OCBrowse:require('./components/categories/OpenInCatalogBrowse.vue').default,

        pagination: Pagination,
        chatTextArea:require('./components/core/ChatTextarea.vue').default,
        CommentsThread:require('./components/core/CommentsThread.vue').default,
        TuiImageEditorComponent:require('./components/core/Tui-ImageEditorComponent.vue').default,
        moment: moment,
        tagMetadataComponent: require('./components/files/TagMetadata.vue').default,
        bulkTagMetadataComponent:require('./components/files/BulkTagMetadata.vue').default,
        videoMarkinMakoutSlider: require('./components/core/VideoMarkinMarkoutSlider.vue').default,
        rangeSliderMixin: require('./mixins/RangeSliderMixin.js').default,
        playerAndMarkinMarkoutWrapperComponent: require('./components/markinMarkout/PlayerAndMarkinMarkoutWrapperComponent.vue').default,
        markinMarkoutActions:require('./components/markinMarkout/MarkinMarkoutActions.vue').default,
        sequenceMetadata:require('./components/files/SequenceMetadata.vue').default,
        subclipsRows:require('./components/subclips/SubclipsRows.vue').default,
        copyParentDescription:require('./components/subclips/copyParentDescription.vue').default,
        backButton:require('./components/core/backButton.vue').default,
        catalogMultiselectDropdown:require('./components/categories/CatalogMultiselectDropdown.vue').default,
        properties:require('./components/files/Properties.vue').default,
        manageVersions:require('./components/ManageVersions/ManageVersionsDialog.vue').default,
        departments:require('./components/miscellaneous/departmentsCommonComponent.vue').default,
        advancedSearch:require('./components/core/AdvancedSearch.vue').default,
        sequenceMetadataWithInlineFieldStyles:require('./components/files/SequenceMetadataWithInlineFieldStyles.vue').default,
        confirmDialog:require("./components/miscellaneous/confirmMessageDialog.vue").default,
        catalogsDisplay:require("./components/categories/CatalogsDisplay.vue").default,
        singleUserSelectionFromBrowse:require("./components/userGroups/AddSingleUserFromBrowse.vue").default,
        commentDialog:require("./components/actions/Comment.vue").default,
        subclipComponent:require("./components/subclips/Subclips.vue").default,
        uploadComponent:require("./components/files/Upload.vue").default,
        inlineDeleteIcon: require("./components/core/InlineDeleteIcon.vue").default,
        customAlertMessage: require("./components/actions/customAlertMessage.vue").default,
        subclipPreviewMixin: require("./mixins/SubclipPreviewMixin.js").default,
        customAudioPlayer : require("./components/customAudioPlayer/AudioPlayerComponent.vue").default,
        FileUploaderToCloud: require('./plugins/fileUploadToCloud.js').default,
        FileUploder: require('./plugins/fileUploader.js').default,
        modifyTTL: require('./components/actions/ModifyTTL.vue').default,
        catalogDisplayChildrenRoutes: require('./routes/pages/catalogsdisplay.js').default.children,
        tagMetadataComponentMixin: require("./mixins/TagMetadataComponentMixin.js").default,
        sequenceMetadataComponent:require("./components/files/SequenceMetadata.vue").default,
        sequenceMetadataComponentMixin:require("./mixins/SequenceMetadataComponentMixin.js").default,
        customMetadataFields: require("./components/customMetadata/CustomMetadata.vue").default,
        tagsDropdownComponent: require("./components/tags/TagsSelectionDropdown.vue").default,
        reviewTag: require("./components/miscellaneous/reviewTagDisplay.vue").default,
        createReviewButton: require("./components/miscellaneous/reviewButtonWithDropdown.vue").default,
        AIInteractionComponent: require("./components/ButtonsConfiguration/AIInteraction.vue").default,
        ConfiguredButtonsComponent: require("./components/ButtonsConfiguration/ConfiguredButtons.vue").default,
        ButtonsBrowseComponent: require("./components/ButtonsConfiguration/ButtonsBrowse.vue").default,
        AIPanelComponent: require("./components/ButtonsConfiguration/AIPanel.vue").default,
        vuex:{ mapActions , mapGetters , mapMutations },
        RichTextEditorComponent,
        DisplayRichTextEditorContents,
        RichtexteditorToggleToolbarButton
}